import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LegalCmsPage, { TERMS_PAGE_ID } from "./LegalCmsPage";

const TermsCondition: React.FC = () => {
  const { t: translation } = useTranslation();
  return (
    <LegalCmsPage
      pageId={TERMS_PAGE_ID}
      failedKey="terms_load_failed"
      extra={
        <p>
          {translation("privacy_policy_link_prefix")}{" "}
          <Link to="/privacy-policy">{translation("privacy_policy").replace(/^&\s*/, "")}</Link>
        </p>
      }
    />
  );
};

export default TermsCondition;
